// Ported from packages/desk/src/mobile/AppGrid.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * The home grid: at most five primary apps and More, three to a row (two on a phone under 360 px, so no name shrinks
 * below reading size). More opens the App Library.
 */
import type { RadarAppDefinition } from "../../apps/registry";
import { AppIcon } from "./AppIcon";
import { MoreGlyph } from "./glyphs";
import { gridColumns } from "./layout";

export function AppGrid({
  apps,
  width,
  accentId,
  onOpen,
  onActions,
  onMore,
}: {
  apps: RadarAppDefinition[];
  width: number;
  /** The app opened last, which keeps the accent until another one is opened. */
  accentId: string | null;
  onOpen: (app: RadarAppDefinition) => void;
  onActions: (app: RadarAppDefinition, anchor: HTMLElement) => void;
  onMore: () => void;
}) {
  return (
    <div className="rdr-mgrid" role="group" aria-label="Apps" data-rdr-grid="" style={{ gridTemplateColumns: `repeat(${gridColumns(width)}, minmax(0, 1fr))` }}>
      {apps.map((a) => {
        const badge = a.badge?.();
        return (
          <AppIcon
            key={a.id}
            id={a.id}
            name={a.short ?? a.name}
            icon={a.icon}
            badge={badge}
            accent={a.id === accentId || Boolean(badge)}
            onOpen={() => onOpen(a)}
            onActions={(el) => onActions(a, el)}
          />
        );
      })}
      <AppIcon id="more" name="More" icon={<MoreGlyph />} hasActions={false} onOpen={onMore} data="more" />
    </div>
  );
}
